var _style, _defs, _path, _path2, _path3, _path4, _path5, _defs2, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{display:inline;clip-path:url(#SVGID_00000089570193375473728930000006114859786238963090_);}\r\n\t.st3{fill:#E86E7B;}\r\n\t.st4{clip-path:url(#SVGID_00000050629777159558725440000000959449754493453223_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106853747301347604430000017128200109430219416_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      clipPath: "url(#SVGID_00000106853747301347604430000017128200109430219416_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3C7,0.4,5.9,0,4.8,0 s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9c2.4,2.4,5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2 c0.8-0.8,1.2-1.9,1.2-3s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 c-1.1,0-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2s-2.2,0.4-3,1.2 c-0.8,0.8-1.2,1.9-1.2,3v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 c-1.1,0-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000045585550089350489070000007484130510264602792_",
    x: 2.6,
    y: 4.6,
    width: 95.7,
    height: 95.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000015334725541434016940000016527777193492370836_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000045585550089350489070000007484130510264602792_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000015334725541434016940000016527777193492370836_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.4,84.3H22.5c-5.3,0-10.4-2.1-14.1-5.8c-3.7-3.7-5.8-8.8-5.8-14.1V24.5c0-5.3,2.1-10.4,5.8-14.1 c3.7-3.7,8.8-5.8,14.1-5.8h39.9c5.3,0,10.4,2.1,14.1,5.8c3.7,3.7,5.8,8.8,5.8,14.1v39.9c0,5.3-2.1,10.4-5.8,14.1 C72.8,82.2,67.7,84.3,62.4,84.3z M22.5,12.6c-3.2,0-6.2,1.3-8.5,3.5c-2.2,2.2-3.5,5.3-3.5,8.5v39.9c0,3.2,1.3,6.2,3.5,8.5 c2.2,2.2,5.3,3.5,8.5,3.5h39.9c3.2,0,6.2-1.3,8.5-3.5c2.2-2.2,3.5-5.3,3.5-8.5V24.5c0-3.2-1.3-6.2-3.5-8.5 c-2.2-2.2-5.3-3.5-8.5-3.5H22.5z M98.3,80.3V28.5c0-1.1-0.4-2.1-1.2-2.8c-0.7-0.7-1.8-1.2-2.8-1.2s-2.1,0.4-2.8,1.2 c-0.7,0.7-1.2,1.8-1.2,2.8v51.8c0,3.2-1.3,6.2-3.5,8.5c-2.2,2.2-5.3,3.5-8.5,3.5H26.5c-1.1,0-2.1,0.4-2.8,1.2 c-0.7,0.7-1.2,1.8-1.2,2.8s0.4,2.1,1.2,2.8c0.7,0.7,1.8,1.2,2.8,1.2h51.8c5.3,0,10.4-2.1,14.1-5.8C96.2,90.7,98.3,85.6,98.3,80.3z "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.9a861fadf0b6493b14762ed8d425bae1.svg";
export { ForwardRef as ReactComponent };